import { PortfolioCard } from "./card";
import { combineReducers, createStore } from "redux";
import { UrlBuilderState } from "./url-builder";
import { UrlBuilderPublicState } from "./url-builder-public";
import ConfigReducer, { ConfigState } from "./config/reducer";
import UrlBuilderReducer from "./url-builder/reducer";
import UrlBuilderPublicReducer from "./url-builder-public/reducer";
import CardReducer from "./card/reducer";

export interface ApplicationState {
  urlBuilder: UrlBuilderState;
  urlBuilderPublic: UrlBuilderPublicState;
  card: PortfolioCard;
  config: ConfigState;
}

export default createStore(
  combineReducers({
    urlBuilder: UrlBuilderReducer,
    urlBuilderPublic: UrlBuilderPublicReducer,
    card: CardReducer,
    config: ConfigReducer,
  })
);
